import { wrapLastWord } from '../utils';

const handler = ( $ ) => {
	/**
	 * Add doodle to the last word of the title.
	 */
	const $title = $( '.home-hero__title' );

	if ( $title.length == 0 ) {
		return;
	}

	const titleText = $title.text();

	$title.html( wrapLastWord( titleText, 'home-hero__doodle' ) );
};

export default ( ( $ ) => $( handler ) )( jQuery );
